import styled from 'styled-components';
import { FlexColumn } from '@elementary/common-ui/components';
import { Typography } from '@mui/material';
import useSupportChat from 'shared/hooks/useSupportChat';
import {
  fontSize,
  fontWeight,
  radius,
} from '@elementary/common-ui/style/utils';

const CONTENT_GAP = '64px';
const LOADER_FONT_SIZE = '7px';
const LOADER_DOT_SHADOW = '0 2.5em 0 -1.3em';
const LOADER_DOT_SHADOW_ACTIVE = '0 2.5em 0 0';

const CenteringWrapper = styled(FlexColumn)`
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  gap: ${CONTENT_GAP};
`;

const Loader = styled.span`
  border-radius: ${radius('round')};
  width: 2.5em;
  height: 2.5em;
  animation-fill-mode: both;
  animation: bblFadInOut 1.8s infinite ease-in-out;
  color: ${({ theme }) => theme.palette.accent.secondary};
  font-size: ${LOADER_FONT_SIZE};
  position: relative;
  text-indent: -9999em;
  transform: translateZ(0);
  animation-delay: -0.16s;

  &:before,
  &:after {
    border-radius: ${radius('round')};
    width: 2.5em;
    height: 2.5em;
    animation-fill-mode: both;
    animation: bblFadInOut 1.8s infinite ease-in-out;
    content: '';
    position: absolute;
    top: 0;
  }

  &:before {
    left: -3.5em;
    animation-delay: -0.32s;
  }
  &:after {
    left: 3.5em;
  }

  @keyframes bblFadInOut {
    0%,
    80%,
    100% {
      box-shadow: ${LOADER_DOT_SHADOW};
    }
    40% {
      box-shadow: ${LOADER_DOT_SHADOW_ACTIVE};
    }
  }
`;

const ClickableText = styled(Typography).attrs(() => ({
  component: 'span',
}))`
  cursor: pointer;
  font-weight: ${({ theme }) => theme.typography.fontWeightBold};
`;

const EnvInitiatingPage = () => {
  const supportChat = useSupportChat();

  return (
    <CenteringWrapper>
      <Loader role="progressbar" aria-label="Initializing Elementary" />
      <FlexColumn sx={{ gap: 2, alignItems: 'center' }}>
        <Typography
          sx={{ fontSize: fontSize('xl'), fontWeight: fontWeight('semibold') }}
        >
          Initializing Elementary...
        </Typography>

        <Typography
          sx={{
            whiteSpace: 'pre',
            textAlign: 'center',
            color: 'content.secondary',
          }}
        >
          Elementary is syncing metadata, logs and results from <br /> your data
          warehouse. <br />
          The first sync might take a few minutes.
        </Typography>

        <Typography sx={{ fontWeight: fontWeight('semibold') }}>
          Having any issues?{' '}
          <ClickableText onClick={supportChat.show}>Contact us</ClickableText>
        </Typography>
      </FlexColumn>
    </CenteringWrapper>
  );
};

export default EnvInitiatingPage;
